import { useDispatch } from "react-redux";
import { useLazyGetAgreementQuery } from "../../../Store/Builder/techsbook.api";
import showToast from "../../Hooks/toast";
import { setLoader } from "../../../Store/Slice/techsbookSlice";
import { useState } from "react";

const useTerms = () => {
  const dispatch = useDispatch();
  const [getAgreement] = useLazyGetAgreementQuery();

  const [agreement, setAgreement] = useState([]);

  const get = (params) => {
    dispatch(setLoader(true));
    getAgreement(params)
      .unwrap()
      .then((res) => {
        dispatch(setLoader(false));
        setAgreement(res);
      })
      .catch((err) => {
        dispatch(setLoader(false));
        showToast(err?.data?.message ?? "Error", "error");
      });
  };

  return {
    get,
    agreement,
  };
};

export default useTerms;
